/**
 * ? MenuController
 * @package de Zalm Property
 * 
 * Controlls diffrent menu items and controls state
 * to manipulate animations/appearance
 */

export default class menuController {
    constructor() {

        // If hash redirect was used, remove it
        if (document.location.hash != '')
            this.removeHash(100);

        // Turn off single page navigation if on a project page
        // This will return to home with hashed location
        this.singlePageNavigation = true;
        if (document.body.classList.contains('single-project'))
            this.singlePageNavigation = false;

        // Setup global class property's
        this.props = {
            activeItem : document.querySelector('#mainNavExt ul li a'),
            menuListItems : document.querySelectorAll('#mainNavExt ul li'),
            linkItems : document.querySelectorAll('#mainNavExt ul li a'),
            menuWrapper : document.getElementById('mainNavExt')
        }
        // Set the first item to active
        this.props.activeItem.dataset.itemActive = true

        // Add event listener to toggle main navigation menu
        // Call toggleOpen with open/close argument
        const menuButton = document.getElementById('openNavigation');
        menuButton.addEventListener('click', (e) => {
            if (this.props.menuWrapper.dataset.menuActive == "true")
                this.toggleOpen(false);
            else
                this.toggleOpen(true);
        });

        // Add event listeners to all links in menu
        // Call gotoSection method once clicked
        [].forEach.call(this.props.linkItems, (item) => {
            item.addEventListener('click', (event) => {
                event.preventDefault();
                this.gotoSection(event);
            })
        })

    }

    gotoSection(event) {
        // If not on home page just send em back home
        if (!this.singlePageNavigation) {
            window.location.replace('/' + event.target.hash);
            return
        }

        // Call toggleOpen with close argument to close menu
        this.toggleOpen(false);

        // Get hash of clicked element
        const sendTarget = event.target.hash.substr(1);
        // Get distance to scroll from getDistance method
        // Scroll to target
        window.scrollTo(this.getDistance(sendTarget));

        // Call changeActive method to highlight correct item
        this.changeActive(event.target);        
    }

    changeActive(target) {
        // Remove active attribute from previous item
        this.props.activeItem.dataset.itemActive = false;

        // Add active attribute to next item
        target.dataset.itemActive = true;
        
        // Store new active item in props for later use
        this.props.activeItem = target;
    }

    toggleOpen(toggle) {   
        // Call stopScroll method to prevent page scrolling
        this.stopScroll(toggle);
        // Add active attribute to menu wrapper
        this.props.menuWrapper.dataset.menuActive = toggle;

        // Loop over each menu item and animatie them in
        // Data aatribute styling used with CSS @keyframes
        [].forEach.call(this.props.menuListItems, (item, index) => {            
            setTimeout( () => {
                item.dataset.itemOpen = toggle;
            }, (150 + (index * 100)))
        })
    }

    getDistance(target) {
        // If home is click just scroll to top
        if (target == '')
            return {
                top: 0,
                behavior: 'smooth'
            };

        // Get target position and current scroll position
        const   element  = document.getElementById(target),
                scroll   = element.getBoundingClientRect().top;

        // Calculate distance needed to scroll and return the values
        return {
            top: (scroll + window.scrollY - 100),
            behavior: 'smooth'
        }
    }

    stopScroll(toggle) {
        // Toggle menuOpen attribute on body
        // Used to prevent scrolling
        document.body.dataset.menuOpen = toggle;
    }

    // After a set timeout, remove the hash from the url bar
    removeHash(timeout) { 
        window.setTimeout(() => {
            history.replaceState("", document.title, window.location.pathname + window.location.search);
        }, timeout)
    }

}